import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { ApiKeysWebService } from './apikeys.web.service';
import { ApiKeyDto, ApiKeyTransferResultDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { List } from 'DiscoveryEngine.TS/Utils';


@Injectable()
export class ApiKeysService implements OnDestroy {

	constructor(private apiKeysWebService: ApiKeysWebService) {
		return;
	}

	public ngOnDestroy(): void {
		return;
	}

	public getApiKeys(): Observable<List<ApiKeyDto>> {
		return this.apiKeysWebService.getApiKeys();
	}

	public createApiKey(apiKey: ApiKeyDto): Observable<ApiKeyDto> {
		return this.apiKeysWebService.createApiKey(apiKey);
	}

	public updateApiKey(apiKey: ApiKeyDto): Observable<ApiKeyDto> {
		return this.apiKeysWebService.updateApiKey(apiKey);
	}

	public deleteApiKey(apiKeyGuid: string): Observable<boolean> {
		return this.apiKeysWebService.deleteApiKey(apiKeyGuid);
	}

	public doApiKeyTransfer(apiKeyGuid: string, oldUserGuid: string, newUserGuid: string): 
							Observable<ApiKeyTransferResultDto> {
		return this.apiKeysWebService.doApiKeyTransfer(apiKeyGuid, oldUserGuid, newUserGuid);
	}

}
